import { render, staticRenderFns } from "./PrebidData.vue?vue&type=template&id=18310e70"
import script from "./PrebidData.vue?vue&type=script&lang=js"
export * from "./PrebidData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports